export default __webpack_public_path__ + "static/media/science-img-four.07859d7e.png";